import {
  styled,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { FlexContainer } from '@/reports/shared/OverviewItems/components';
import { Text } from '@/theme/index';

export const StyledAccordion = styled(Accordion)(() => ({
  boxShadow: 'none',
  bottom: 0,
  width: '100%',
}));

export const TableContainer = styled('div')(() => ({
  width: '100%',
}));

export const AdjustedAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => ({
    padding: '0px',
    [theme.breakpoints.up('sm')]: {
      padding: '0px 16px',
    },
  })
);

export const AdjustedAccordionDetails = styled(AccordionDetails)(
  ({ theme }) => ({
    padding: '0px',
    [theme.breakpoints.up('sm')]: {
      padding: '8px 16px 16px',
    },
  })
);

export const HeaderFlexContainer = styled(FlexContainer)(() => ({
  flexDirection: 'column',
}));

export const CurrentLocationContainer = styled('div')(() => ({
  display: 'flex',
}));

export const AdjustedFlexContainer = styled(FlexContainer)(() => ({
  marginTop: '2px !important',
}));

export const TableTitle = styled(Text)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '16px',
  width: '126px',
  flexShrink: 0,

  [theme.breakpoints.up('sm')]: {
    width: '145px',
  },
}));
